<template>
  <details-hero-page-resolver
    :route-name="routeName"
    :resolvers="resolvers"
  >
    <template v-slot:preloader>
      <history-details>
        <template v-slot:breadcrumbs>
          <tm-breadcrumbs-wrapper
            without-padding
            class="mb-4"
          >
            <tm-breadcrumbs-skeleton
              :count="3"
              class="py-2"
            />
          </tm-breadcrumbs-wrapper>
        </template>

        <tm-skeleton-hero-details-flat
          class="mb-4"
          :btn-count="btnCount"
        />

        <div class="d-flex flex-column gap-5">
          <slot name="loader" />
        </div>
      </history-details>
    </template>
  </details-hero-page-resolver>
</template>

<script setup lang="ts">
import DetailsHeroPageResolver from '@/components/resolvers/DetailsHeroPageResolver.vue'
import TmBreadcrumbsSkeleton from '@/components/shared/skeletons/TmBreadcrumbsSkeleton.vue'
import TmSkeletonHeroDetailsFlat from '@/components/shared/skeletons/TmSkeletonHeroDetailsFlat.vue'
import type { Resolvers } from '@/services/types'
import TmBreadcrumbsWrapper from '@/components/shared/TmBreadcrumbsWrapper.vue'
import { computed } from '@/composition/vue/compositionApi'
import { useBreakpoints } from '@/composition/breakpoints'
import HistoryDetails from '@/components/views/reporting/history/HistoryDetails.vue'

defineOptions({ inheritAttrs: false })
defineProps<{
  resolvers: Resolvers
  routeName: string
}>()

const { isSmBreakpoint, isLargeLaptop } = useBreakpoints()

const btnCount = computed(() => {
  if (isSmBreakpoint.value) {
    return 1
  }
  if (isLargeLaptop.value) {
    return 2
  }

  return 3
})
</script>
